import {
  FLIGHTDETAILS_FETCH_SUCCESS,
  FLIGHTDETAILS_FETCH_INVOKED,
  FLIGHTDETAILS_FETCH_FAILED,
} from "src/redux/actions/flightDetails";
import { FlightSegment } from "src/types/Flight";
import { Passenger } from "src/types/Passenger";

export interface UpcomingFlightI {
  id: string;
  passengers: Passenger[];
  flightInfo: FlightSegment;
}

export interface FlightDetailsI {
  [key: string]: {
    loading: boolean;
    error?: Error;
    data: UpcomingFlightI[];
  };
}

export const initialState: FlightDetailsI = {};

type FlightDetailsFetchInvokedI = {
  type: typeof FLIGHTDETAILS_FETCH_INVOKED;
  id: string;
};

type FlightDetailsFetchSuccessI = {
  type: typeof FLIGHTDETAILS_FETCH_SUCCESS;
  id: string;
  payload: UpcomingFlightI[];
};

type FlightDetailsFetchFailedI = {
  type: typeof FLIGHTDETAILS_FETCH_FAILED;
  id: string;
  error: Error;
};

export type FlightDetailsAction =
  | FlightDetailsFetchInvokedI
  | FlightDetailsFetchSuccessI
  | FlightDetailsFetchFailedI;

const flightDetails = (state = initialState, action: FlightDetailsAction) => {
  const result = { ...state };
  switch (action.type) {
    case FLIGHTDETAILS_FETCH_INVOKED:
      result[action.id] = {
        loading: true,
        data: [],
        error: null,
      };
      return result;
    case FLIGHTDETAILS_FETCH_SUCCESS:
      result[action.id] = {
        loading: false,
        data: action.payload,
      };
      return result;
    case FLIGHTDETAILS_FETCH_FAILED:
      result[action.id] = {
        data: [],
        loading: false,
        error: action.error,
      };
      return result;
    default:
      return state;
  }
};

export default flightDetails;
